<app-time-log-table [dialogData]="this.dialogData" [timeLogDialog]="true" />
